module.exports = __webpack_public_path__ + "media/images/front/month_to_year-66c7523b3404bcd92d485ec2ce1e5335.png";